import React from "react";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";

const ResourcesMenuIcon = () => {
  return <AssignmentOutlinedIcon sx={{ fontSize: "25px" }} />;
};

export default ResourcesMenuIcon;
